import { defineComponent as B, computed as l, createBlock as y, openBlock as o, unref as r, withCtx as I, createElementBlock as i, createCommentVNode as u, createElementVNode as k, toDisplayString as s, mergeProps as C } from "vue";
import { RevInputText as L } from "@ds/components/InputText";
import w from "../../icons/generated/IconCalendar.vue2.js";
import { useLocale as A } from "@ds/plugin";
const g = {
  key: 0,
  class: "text-static-default-low caption mt-8"
}, E = { key: 0 }, T = /* @__PURE__ */ B({
  name: "RevInputDate",
  __name: "InputDate",
  props: {
    clearButtonAriaLabel: { default: void 0 },
    description: { default: void 0 },
    disabled: { type: Boolean },
    enteredDateLabel: { default: void 0 },
    hasClearButton: { type: Boolean, default: !0 },
    error: { default: void 0 },
    id: {},
    label: {},
    modelValue: {},
    pickedDateAttrs: {}
  },
  emits: ["update:modelValue", "input", "invalid", "valid", "clear"],
  setup(c, { emit: p }) {
    const t = c, a = p, m = A(), n = l(() => !!t.modelValue), d = l(
      () => typeof t.enteredDateLabel < "u"
    ), v = l(() => n.value ? new Intl.DateTimeFormat(m.value, {
      dateStyle: "long"
    }).format(new Date(t.modelValue)) : void 0), b = (e) => {
      a("update:modelValue", e);
    }, f = (e) => {
      a("input", e);
    }, h = (e) => {
      a("invalid", e);
    }, V = () => {
      a("valid");
    }, D = () => {
      a("clear");
    };
    return (e, _) => (o(), y(r(L), {
      id: e.id,
      class: "relative cursor-text",
      "clear-button-aria-label": e.clearButtonAriaLabel,
      description: e.description,
      disabled: e.disabled,
      error: e.error,
      "has-clear-button": e.hasClearButton,
      icon: r(w),
      label: e.label,
      "model-value": e.modelValue,
      type: "date",
      onClear: D,
      onInput: f,
      onInvalid: h,
      "onUpdate:modelValue": b,
      onValid: V
    }, {
      default: I(() => [
        n.value ? (o(), i("div", g, [
          d.value ? (o(), i("span", E, s(e.enteredDateLabel), 1)) : u("", !0),
          k("span", C(e.pickedDateAttrs, {
            class: { "ml-2": d.value }
          }), s(v.value), 17)
        ])) : u("", !0)
      ]),
      _: 1
    }, 8, ["id", "clear-button-aria-label", "description", "disabled", "error", "has-clear-button", "icon", "label", "model-value"]));
  }
});
export {
  T as default
};
